import script from "./AuthManage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthManage.vue?vue&type=script&setup=true&lang=ts"

import "./AuthManage.vue?vue&type=style&index=0&id=52137e3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52137e3e"]])

export default __exports__